<template>
  <div class="report">

    <h1 class="indigo--text text-xs-center my-2 text--lighten-2">Report Something</h1>

    <h1 class="headline text-xs-center" v-if="signedIn !== true">Sorry,Only Logged in Users Can Report</h1>

    <v-container class="my-2" v-else> <!-- v-continer would be the root of the flex box -->
        <v-form>
            <v-layout column align-center justify-center> <!-- Layout is a row/column of content -->

                <v-flex xs8 md3>
                    <v-btn block flat class="blue lighten-3 white--text" large @click="geolocation()">Get Location</v-btn>
                </v-flex>

                <v-flex xs8 md3>
                    <p v-if="geoLocated === false" class="error pa-1 white--text">Your location is needed to send a Report.</p>
                    <p class="success pa-1 white--text" v-else>Location was kept: {{`(${curLat},${curLong})`}}</p>
                </v-flex>

                <v-flex xs12 md9 > <!-- Elments that make the layout ~~ Container Element --> <!--On Small Screens, Flex item will be full width of 12-->
                    <v-select v-model="curCat" :items="categories" label="Category" :rules="inputRules" ref="form"> </v-select>
                </v-flex>

                <!-- All Different Category stuff -->

                <v-flex xs12 md9 v-if="curCat === 'Accident'">
                    <v-select v-model="curType" :items="types.accidents" label="Type"> </v-select>
                </v-flex>

                <v-flex xs12 md9 v-if="curCat === 'Dangers'">
                    <v-select v-model="curType" :items="types.dangers" label="Type"> </v-select>
                </v-flex>

                <v-flex xs12 md9 v-if="curCat === 'Misc.' || curCat === 'Complaints' || curType ==='Misc.'">
                    <v-text-field v-model="curTitle" :counter="50" label="Title" required></v-text-field>
                </v-flex>

                <v-flex xs12 md8 v-if="curCat ==='Misc.' || curType ==='Misc.' || curCat ==='Complaints'">
                    <v-textarea name="miscInput" label="Additional Information" flat v-model="curMisc"></v-textarea>
                </v-flex>

                <!--Upload button for image -->

                <v-flex xs12 md9>
                    <v-upload-button title="Upload Image" color="blue lighten-3 white--text" :fileChangedCallback="fileHandler" depressed large>
                        <template slot="icon-left"> <!--Since the upload button is a component, it uses the slot 'icon-left' -->
                            <v-icon left>photo</v-icon>
                        </template>
                    </v-upload-button>
                </v-flex>

                <v-flex xs8 md3>
                    <p v-if="curImage === '' " class="error pa-1 white--text">A image is required to send a report</p>
                    <p class="success pa-1 white--text" v-else>Image Kept</p>
                </v-flex>

                <!--Current Speed Category -->

                <v-flex xs12 md9>
                    <v-select v-model="curSpeed" :items="types.speed" label="Current User Speed"></v-select>
                </v-flex>

                <!--Submit Button -->

                <v-flex xs8 md3>
                    <v-btn block flat class="blue lighten-3 white--text" large @click.once="Submit()">Submit</v-btn>
                </v-flex>

                <!--Success Message -->

                <v-flex xs8 md3 v-if="success">
                    <p class="text-weight-bold headline success pa-3 white--text ma-2">Thank You For Submitting!</p>
                </v-flex>

            </v-layout>
        </v-form>

    </v-container>
  </div>
</template>

<script>
import {firebase} from '@firebase/app';
import {database,auth,storage} from '@/fb.js';
import UploadButton from 'vuetify-upload-button';
const storageReference = storage.ref(); //reference to storage
export default {
  name: 'ReportPage',
  props: {
      signedIn: Boolean
  },

  components: {
      'v-upload-button': UploadButton
  },

  data () {
      return {
          curCat: '', //all the data objects
          curType: '',
          curTitle: '',
          curSpeed: '',
          curMisc: '',
          curImage: '',
          curLat: 0,
          curLong: 0,

          acualImage: null,

          geoLocated: false,
          success: false,

          categories: ["Accident","Dangers","Complaints","Misc."],
          inputRules: [
              value => value.length > 0 || 'Please give a input!'
          ],
          types: {
            accidents: [
                'Rear-End Collision',
                'Side-Impact Collision',
                'Sideswipe Collision',
                'Rollover',
                'Head On Collisions',
                'Single Car Accident',
                'Multiple Vechicle Pile-Up',
                'Misc.'
            ],
            dangers: [
                'Forest-Fires',
                'Pot-holes',
                'Uprooted Trees',
                'Misc.'
            ],
            complaints: [
                'Streetways & Sidewalks',
                'Pedestrians',
                'Freeways',
                'Bridges and Tunnels',
                'Misc.'
            ],
            speed: [
                '5<',
                '5-25',
                '25-45',
                '45-60',
                '60+'
            ]
          }
      }
  },
  methods: {
      Submit: function() { //checks and submits everything
          if(this.$refs.form.validate() && this.curType !== 0 && this.curLong !== 0 && this.curLat !== 0 && this.curImage !== '') { //gets reference
              
              const submissionData = {
                  user: auth.currentUser.uid,
                  userAvatar: auth.currentUser.photoURL,
                  userName: auth.currentUser.displayName,
                  category: this.curCat,
                  title: this.curTitle.length > 0 ? this.curTitle : 'none',
                  type: this.curType,
                  image: this.curImage,
                  misc: this.curMisc.length > 0 ? this.curMisc : 'User Has Decided not to Describe the situation',
                  speed: this.curSpeed,
                  long: this.curLong,
                  specialID: this.generateRandomID(7),
                  lat: this.curLat,
                  comments: [],
                  verified: false,
                  timestamp: firebase.firestore.FieldValue.serverTimestamp()
              }

              database.collection('Pins').add(submissionData).then(() => { //sends the object to the database

                storageReference.child(this.curImage).put(this.actualImage).then(() => {
                    this.success = true;
                });

              });

          }
      },
      fileHandler(file) {
          if(file.type === "image/png" || file.type === "image/jpeg") {
              this.actualImage = file;
              this.curImage = `userImages/${auth.currentUser.uid}/${file.name}`
          } else {
              this.acualImage = null;
              this.curImage = '';
          }
      },
      geolocation() {
        navigator.geolocation.getCurrentPosition(this.buildUrl, this.geoError);
      },
      buildUrl(position) {
        this.curLat = position.coords.latitude;
        this.curLong = position.coords.longitude;
        this.geoLocated = true;
      },
      geoError(error) {
          this.geolocated = false;
          alert(error);
      },
      generateRandomID(length) {
          var text = "";
          var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
          for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
          return text;
      }

  }
}
</script>